
import PopupHeader from 'vux/src/components/popup-header/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Radio from 'vux/src/components/radio/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Tabbar from 'vux/src/components/tabbar/tabbar.vue'
import TabbarItem from 'vux/src/components/tabbar/tabbar-item.vue'

import { formatDateTime } from '../../utils/utils'
export default {
name: 'Attendance-compoment',
directives: {
TransferDom
},
components: {
XHeader, Group, Cell, CellBox, Flexbox, FlexboxItem, Radio, PopupHeader, Popup, XTextarea, XButton, Tabbar, TabbarItem
},
data () {
return {
baseUrl: this.$store.state.url,
userName: false,
lng: 113.35131293562,    // 经度
lat: 23.147133650274,    // 纬度
nearbyAddress: [],     // 保存在选择器里面的数据
attendancePlaceList: [],   // 保存考勤地点的数据
selectArea: {},
areaCtrl: false,
popupData: '',
nowDate: '',
timestamp: 0,
timestampInterval: {},
thisWeek: '',
thisPlace: {},  // 选择的考勤地点
thisPlaceHasChange: false,
eventOffDuty: {},  // 下班时间
eventOnDuty: {},   // 上班时间
timeLabel: '',
timeValue: '',  // 显示的时间
canAppSign: false,  // 能否打卡
userId: '',
mapHeight: 0,  // 地图高度
attendanceType: false, // 打卡类型  false位考勤打卡  true为不限范围打卡
attendanceNearArea: [], // 定位打卡附近的地点
}
},
mounted () {
this.mapHeight = window.innerHeight - 187
if (this.$store.state.userInfo.accounts) {
console.log(this.$store.state.userInfo)
this.userName = this.$store.state.userInfo.accounts
};


this.axios({
url: this.$store.state.url + '/wechat/login/user',
method: 'get',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then((response) => {
this.userId = response.data.account.id
console.log(this.userId)
this.getLocation()

}).catch((response) => {
console.log(response)
})

},
methods: {
getLocation () {
wx.getLocation({
type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success: (res) => {
var ggPoint = new BMap.Point(res.longitude, res.latitude)
var convertor = new BMap.Convertor()
var pointArr = []
pointArr.push(ggPoint)
convertor.translate(pointArr, 1, 5, (data) => {
if (data.status === 0) {
console.log(data)
this.lng = data.points[0].lng
this.lat = data.points[0].lat
this.getAttendanceInfo()
}
})
},
cancel: function (res) {
console.log('去你的cancel', res)
},
fail: (res) => {
debugger
console.log('去死fail', res)
}
})
},
goLogin () {
this.$router.push({ name: 'Login'})
},

getAttendanceInfo () {
console.log(this.lng, this.lat, this.userId)
this.$vux.loading.show({
text: '加载中'
})
this.axios({
url: this.$store.state.url + '/app/getAttendanceInfo?userId=' + this.userId,
method: 'get',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then((response) => {
this.attendancePlaceList = response.data.attendancePlaceList
this.eventOffDuty = response.data.eventOffDuty
this.eventOnDuty = response.data.eventOnDuty
response.data.attendancePlaceList.forEach((item, index) => {
if (index == 0) {
this.nearbyAddress.push(item.name)
this.popupData = item.name
this.thisPlace = item
} else {
this.nearbyAddress.push(item.name)
}
})
this.changeMapHeight()

this.$vux.loading.hide()
}).catch((response) => {
this.$vux.loading.hide()
})
},

init_map () {
let that = this
var ggPoint = new BMap.Point(this.lng, this.lat)

that.bMap = new BMap.Map(this.$refs.allmap)
that.bMap.centerAndZoom(ggPoint, 18)
that.bMap.addControl(new BMap.NavigationControl())

var pointArr = []
pointArr.push(ggPoint)
var marker = new BMap.Marker({lng: this.lng, lat: this.lat})
var circle = new BMap.Circle({lng: that.thisPlace.longitude, lat: that.thisPlace.latitude}, that.thisPlace.hitCardDistance, {strokeColor: '#459FFB', fillColor: '#459FFB', strokeWeight: 1, strokeOpacity: 0.3}) 
that.bMap.addOverlay(marker)
that.bMap.addOverlay(circle)            
that.bMap.setCenter([{lng: this.lng, lat: this.lat}])
var ggPointAfter = new BMap.Point(this.lng, this.lat)

var gc = new BMap.Geocoder()
that.attendanceNearArea = []
gc.getLocation(ggPointAfter, function (rs) {
console.log(rs)





rs.surroundingPois.forEach((item, index) => {
if (index == 0) {
that.attendanceNearArea.push({
select: true,
title: item.title
})
that.nearAreaText = item.title
that.selectArea = item.title
} else {
that.attendanceNearArea.push({
select: false,
title: item.title
})
}
})
}, {
poiRadius: 1000,           // 半径为r米内的POI,
numPois: 12             
})
this.isIntoCircle()
},
changeArea () {
this.areaCtrl = true
},

reGetLocation () {
this.init_map()
},
changePlace (value, label) {
if (!this.thisPlaceHasChange) {
this.thisPlaceHasChange = true
var ggPoint = new BMap.Point(this.lng, this.lat)
this.bMap.centerAndZoom(ggPoint, 18)
} else {
this.popupData = value
this.attendancePlaceList.forEach((item) => {
if (item.name == value) {
this.thisPlace = item
}
})
this.changeMapHeight()
this.areaCtrl = false
this.bMap.clearOverlays()
var marker = new BMap.Marker({lng: this.lng, lat: this.lat})
var circle = new BMap.Circle({lng: this.thisPlace.longitude, lat: this.thisPlace.latitude}, this.thisPlace.hitCardDistance, {strokeColor: '#459FFB', fillColor: '#459FFB', strokeWeight: 1, strokeOpacity: 0.3}) 
this.bMap.addOverlay(marker)
this.bMap.addOverlay(circle)            
var ggPoint = new BMap.Point(this.lng, this.lat)
this.bMap.centerAndZoom(ggPoint, 18)
this.isIntoCircle()
}
},

isIntoCircle () {
if (this.thisPlace.hitCardDistance == 0) {
this.canAppSign = true
} else {
var pt = new BMap.Point(this.lng, this.lat)
var c = new BMap.Point(this.thisPlace.longitude, this.thisPlace.latitude) 
var circle = new BMap.Circle(c, this.thisPlace.hitCardDistance)

var result = BMapLib.GeoUtils.isPointInCircle(pt, circle)
if (result) {
this.canAppSign = true
} else {
this.canAppSign = false
}
}
},

appSign () {
if (!this.canAppSign) {
this.$vux.alert.show({
title: '您未进入考勤范围',
content: '您未进入考勤范围'
})
} else {
this.$vux.loading.show({
text: '正在打卡中'
})
let area_name = ''
if (this.thisPlace.hitCardDistance == 0) {

area_name = this.selectArea
} else {
area_name = this.popupData
}
this.axios({
url: this.$store.state.url + '/app/appSign?userId=' + this.userId + '&phone=' + '&source_from=3&longitude=' + this.lng + '&latitude=' + this.lat + '&area_name=' + area_name + '&remark=',
method: 'get',
headers: {
'Accept': 'application/json',
'Content-Type': 'application/x-www-form-urlencoded'
}
}).then((response) => {
this.$vux.loading.hide()
if (response.data.result == '0000') {
this.$vux.alert.show({
title: '打卡成功',
content: '打卡成功'
})
} else {
this.$vux.alert.show({
title: '打卡失败',
content: '打卡失败'
})
}
console.log(response.data)
}).catch((response) => {
console.log(response)
})
}
},

changeMapHeight () {
console.log(this.thisPlace)
if (this.thisPlace.hitCardDistance != 0) {
this.mapHeight = window.innerHeight - 187
this.attendanceType = false
} else {
this.mapHeight = 250
this.attendanceType = true
}
this.init_map()
},

selectThisArea (data) {
this.attendanceNearArea.forEach((item) => {
item.select = false
})
data.select = true
this.selectArea = data.title
},

}
}



// WEBPACK FOOTER //
// ./src/components/attendance/Attendance-compoment.vue